module.exports = __webpack_public_path__ + "img/right-arrow.f9d962d7.png";